import routeName from '../constant';
import { guideRoutes } from '@/utils/guideRoutes';

const routes = [{
    path: 'assign-contact-terms',
    name: routeName.ASSIGN_CONTACT_DESCRIPTION,
    component: () => import('@/views/aplCatl640and631/BA/landingPage/Index.vue'),
    meta: { auth: true, metaTitle: '指定聯絡人作業說明', leaveAlert: true, code: 'BA', unableBack: true },
},
{
    path: 'assign-contact',
    name: routeName.ASSIGN_CONTACT,
    component: () => import('@/views/aplCatl640and631/BA/radioForm/Index.vue'),
    meta: { auth: true, metaTitle: '指定聯絡人作業', leaveAlert: true, code: 'BA', unableBack: true },
    beforeEnter: (to, from, next) => {
        const whiteList = [routeName.ASSIGN_CONTACT_DESCRIPTION, routeName.CONFIRM_DATA];
        const guideRoute = guideRoutes(from, whiteList, true);
        next(guideRoute);
    },
}];

export default routes;
